module.exports = __webpack_public_path__ + "static/media/DWZ_01.966261d5.jpg";